import React, {useEffect, useState} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';
import {Select} from 'components/Form';
import {FileProperties} from 'ui';
import coursesApiClient from 'utils/coursesApiClient';
import {Upload, Row, Col, Button, message, FormInstance, Form, Slider, InputNumber, Tooltip} from 'antd';
import Spinner from 'components/Spinner';
import {Input, TextArea} from "components/Form";
import debounce from 'lodash.debounce';

import useQueryApiClient from 'utils/useApiClient';

const formItemLayout = {
    labelCol: {span: 6},
    wrapperCol: {span: 18},
};

interface EmbeddedDocFormInterface {
    activityId: number;
    courseId: number;
    embeddedSrc: string;
    form: FormInstance;
    handleVersionSelect: Function;
    language: string;
    material: any;
    parseSrc: Function;
    reloadVersions: Function;
    setMaterial: React.Dispatch<React.SetStateAction<any>>;
    versionList: any[];
    versionsLoading: boolean;
}

const EmbeddedDocForm: React.FC<EmbeddedDocFormInterface> = ({
    activityId,
    courseId,
    embeddedSrc,
    form,
    handleVersionSelect,
    language,
    material,
    parseSrc,
    reloadVersions,
    setMaterial,
    versionList,
    versionsLoading,
}) => {
    const intl = useIntl();

    const {appendData: create} = useQueryApiClient({
        request: {
            url: `/api/v1/courses/${courseId}/activities/${activityId}/material/add`,
            method: 'POST'
        },
        onSuccess: async (response: any): Promise<void> => {
            setMaterial(response.material.settings);

            const versions = await reloadVersions();

            const lastVersion: any = Object.values(versions).pop();

            form.setFieldsValue({
                version: lastVersion + ''
            });
        }
    });

    const storeOptions = debounce(function (value: string) {
        if (value.length > 10) {
            if (!value) {
                return message.error(intl.formatMessage({id: 'courses.embedded_url_error'}));
            }

            const parsedValues = {
                type: 'EMBEDDED_DOC',
                settings: {
                    src: value
                },
                language
            }

            if (material) {
                let fileSettings = JSON.parse(material.fileSettings);
                if (fileSettings.src === value) {
                    return;
                }
            }

            create(parsedValues);
        }
    }, 800);

    return (
        <Spinner spinning={false} opaqueH>
            <TextArea
                customLayout={formItemLayout}
                name="src"
                rows={3}
                label={intl.formatMessage({id: 'courses.embede_doc_src'})}
                validation={{required: true}}
                onChange={(el: any) => parseSrc(el.target.value)}
                onBlur={(el: any) => storeOptions(el.target.value)}
            />
            <Row>
                <Col offset={formItemLayout.labelCol.span}>
                    <div className={'bg-gray p-1 base-border-radius mb-5'}>
                        {embeddedSrc}
                    </div>
                </Col>
            </Row>

            <Input
                customLayout={formItemLayout}
                name='hyperlinkToFile'
                label={intl.formatMessage({id: 'courses.hyperlink_to_file'})}
            />
            <Select
                loading={versionsLoading}
                customLayout={formItemLayout}
                label={intl.formatMessage({id: "general.version"})}
                name='version'
                manualOptions={versionList}
                onChange={(_value: any, options: any) => handleVersionSelect(options.children)}
            />
            <Form.Item {...formItemLayout} name="secondsOnFile" label={intl.formatMessage({ id: "courses.min_seconds_on_file" })}>
                <InputNumber
                    min={0}
                />
            </Form.Item>
        </Spinner>
    )
}
export default EmbeddedDocForm;
